import * as types from '../actions/action-types';

export function getOptionsSuccess(optionsData) {
  return {
    type: types.GET_OPTIONS_SUCCESS,
    optionsData
  };
}

export function propsRecievedOptions(propsRecieved) {
  return {
    type: types.PROPS_RECIEVED_OPTIONS,
    propsRecieved
  };
}



/** WEBPACK FOOTER **
 ** ./src/js/actions/options-actions.js
 **/